"use strict";

module.exports = function (value) {
	value = Number(value);
	if (isNaN(value) || (value === 0)) return value;
	return value > 0 ? 1 : -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/math/sign/shim.js
// module id = 336
// module chunks = 0